import { render } from "./evalDetail.vue?vue&type=template&id=875bcf44&scoped=true"
import script from "./evalDetail.vue?vue&type=script&lang=js"
export * from "./evalDetail.vue?vue&type=script&lang=js"

import "./evalDetail.vue?vue&type=style&index=0&id=875bcf44&scoped=true&lang=scss"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-875bcf44"]])

export default __exports__